import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-q-wang-editor',
  templateUrl: './q-wang-editor.component.html',
  styleUrls: ['./q-wang-editor.component.scss']
})
export class QWangEditorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
